// extracted by mini-css-extract-plugin
module.exports = {"minimumScreenWidth":"320px","mobileScreenWidth":"600px","user":"style_user__2wlFZ","user_avatar":"style_user_avatar__2S7EE","user_name":"style_user_name__3euR3"};